module.exports = __webpack_public_path__ + "img/box6-09.efbdf7f7.png";